export default __webpack_public_path__ + "static/media/selective.1bb76c4a.svg";